import { NgModule } from '@angular/core';;
import { CommonModule, DatePipe } from '@angular/common';
import { ActivityInTimelineComponent } from 'app/shared-modules/timeline/activity-in-timeline/activity-in-timeline.component';
import { CallLogInTimelineComponent } from './call-log-in-timeline/call-log-in-timeline.component';
import { EmailInTimelineComponent } from './email-in-timeline/email-in-timeline.component';
import { FileInTimelineComponent } from './file-in-timeline/file-in-timeline.component';
import { LogInTimelineComponent } from './log-in-timeline/log-in-timeline.component';
import { LogsInTimelineComponent } from './logs-in-timeline/logs-in-timeline.component';
import { NoteInTimelineComponent } from './note-in-timeline/note-in-timeline.component';
import { SmsInTimelineComponent } from './sms-in-timeline/sms-in-timeline.component';
import { TaskInTimelineComponent } from './task-in-timeline/task-in-timeline.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommunicationInTimelineComponent } from './communication-in-timeline/communication-in-timeline.component';
import { NgbPaginationModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CustomPipesModule } from 'app/shared/custom-pipes/custom-pipes.module';
import { HtmlRendrerModule } from 'app/shared-modules/html-rendrer/html-rendrer.module';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { ContactCampaignsHistoryComponent } from './contact-campaigns-history/contact-campaigns-history.component';
import { ThanksioHistoryComponent } from './thanksio-history/thanksio-history.component';
import { VoiceDropInTimelineComponent } from './voice-drop-in-timeline/voice-drop-in-timeline.component';
import { InViewportModule } from '../in-viewport';
import { NpsHistoryComponent } from './nps-history/nps-history.component';
import { ResizableModule } from 'app/setting/custom-form/resize/resizable.module';
import { AngularDateTimePickerModule } from 'app/shared-modules/angular2-datetimepicker';
import { CustomDirectiveModule } from 'app/shared/directive/directive.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { QuillModule } from 'ngx-quill';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ShowAssigneeModule } from 'app/shared/show-assignee/show-assignee.module';



@NgModule({
  declarations: [
    NoteInTimelineComponent,
    FileInTimelineComponent,
    EmailInTimelineComponent,
    ActivityInTimelineComponent,
    LogInTimelineComponent,
    SmsInTimelineComponent,
    TaskInTimelineComponent,
    CallLogInTimelineComponent,
    LogsInTimelineComponent,
    CommunicationInTimelineComponent,
    VoiceDropInTimelineComponent,
    ThanksioHistoryComponent,
    ContactCampaignsHistoryComponent,
    NpsHistoryComponent,
  ],
  imports: [
    ScrollingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbPaginationModule,
    RouterModule,
    CustomPipesModule,
    HtmlRendrerModule,
    NgxAudioPlayerModule,
    InViewportModule,
    AngularDateTimePickerModule,
    CustomDirectiveModule,
    QuillModule,
    VirtualScrollerModule,
    ResizableModule,
    ShowAssigneeModule
  ],
  exports:[
    ThanksioHistoryComponent,
    ContactCampaignsHistoryComponent,
    VoiceDropInTimelineComponent,
    NoteInTimelineComponent,
    FileInTimelineComponent,
    EmailInTimelineComponent,
    ActivityInTimelineComponent,
    LogInTimelineComponent,
    SmsInTimelineComponent,
    TaskInTimelineComponent,
    CallLogInTimelineComponent,
    LogsInTimelineComponent,
    CommunicationInTimelineComponent,
    NpsHistoryComponent,
  ],
  providers:[
    DatePipe
  ]
})
export class TimelineModule { }
